export type RadioGroupButtonsProps = {
    /**
     * Options the user can select.
     */
    options: { label: string; value: string; disabled?: boolean }[];

    /**
     * Internal name to group the radio buttons.
     */
    groupName: string;

    /**
     * Which radio button is selected
     */
    value?: string;

    /**
     * The title explaining the use of the input.
     */
    title?: string;

    /**
     * Callback function invoked when a radio button is selected.
     */
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

function RadioGroupButtons({ groupName, options = [], value, title, onChange, ...props }: RadioGroupButtonsProps): JSX.Element {
    const baseButtonStyle =
        'cursor-pointer relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 peer-focus:z-10 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-indigo-500 peer-focus:border-indigo-500';

    return (
        <>
            {/* Title */}
            <div className="flex justify-between">
                {title && <label className="block text-sm font-medium text-gray-700 mb-1">{title}</label>}
            </div>
            <div className="relative z-0 inline-flex shadow-sm rounded-md">
                <fieldset>
                    {options.map((option, idx) => {
                        const positionStyle = idx === 0 ? 'rounded-l-md' : idx === options.length - 1 ? '-ml-px rounded-r-md' : '-ml-px';
                        const disabledStyle = option.disabled ? 'cursor-default opacity-[0.65]' : '';
                        return (
                            <span key={option.value}>
                                <input
                                    type="radio"
                                    id={groupName + '-' + option.value}
                                    value={option.value}
                                    name={groupName}
                                    checked={option.value === value}
                                    className="fixed opacity-0 w-0 peer"
                                    onChange={(e): void => onChange && onChange(e)}
                                    disabled={Boolean(option.disabled)}
                                    {...props}
                                />
                                <label
                                    className={`${baseButtonStyle} ${positionStyle} ${disabledStyle} peer-checked:bg-indigo-600 peer-checked:border-indigo-600 peer-checked:text-white`}
                                    htmlFor={groupName + '-' + option.value}
                                >
                                    {option.label}
                                </label>
                            </span>
                        );
                    })}
                </fieldset>
            </div>
        </>
    );
}
export default RadioGroupButtons;
